import React from 'react';
import { Button, Modal, Form, Input, Row, Col, Icon } from 'antd';
import { observer, inject } from 'mobx-react';
const FormItem = Form.Item;
import UploadFile from '../UploadFile';
import { addFirmwareFormItemLayout } from '../../const/FormConst';

@inject('appFirmwareStore')
@observer
class AddFirmwareForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fileName: ''
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.changeFileName = this.changeFileName.bind(this);
    this.hideModal = this.hideModal.bind(this);
  }
  onSubmit() {
    this.props.form.validateFields((error, value) => {
      if (!error) {
        const form = new FormData();
        form.append('current_version', value.currentVersion);
        form.append('target_version', value.targetVersion);
        form.append('file', value.file);
        this.props.appFirmwareStore.addFirmware(form);
        this.props.hideAppModal();
        this.props.form.resetFields();
        this.setState({
          fileName: ''
        });
      }
    });
  }
  changeFileName(file) {
    this.setState({
      fileName: (file || {}).name || ''
    });
  }
  hideModal() {
    this.props.hideAppModal();
    this.props.form.resetFields();
    this.setState({
      fileName: ''
    });
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    const { appModal, hideAppModal } = this.props;

    return (
      <div>
        <Modal
          title="上传更新包"
          visible={appModal}
          onOk={this.onSubmit}
          onCancel={this.hideModal}
          okText="确认"
          cancelText="取消"
          width={'50%'}
        >
          {appModal ? (
            <Form onSubmit={this.onSubmit}>
              <FormItem {...addFirmwareFormItemLayout} label="起始版本">
                {getFieldDecorator('currentVersion', {
                  rules: [{ required: true, message: '请输入起始版本!' }]
                })(<Input placeholder="请输入起始版本" />)}
              </FormItem>
              <FormItem {...addFirmwareFormItemLayout} label="目标版本">
                {getFieldDecorator('targetVersion', {
                  rules: [{ required: true, message: '请输入目标版本!' }]
                })(<Input placeholder="请输入目标版本" />)}
              </FormItem>
              <FormItem {...addFirmwareFormItemLayout} label="选择上传更新包">
                {getFieldDecorator('file', {
                  rules: [{ required: true, message: '请选择上传更新包!' }]
                })(<UploadFile callback={this.changeFileName} />)}
              </FormItem>
            </Form>
          ) : null}

          <Row>
            <Col offset={10} span={14}>
              {this.state.fileName && (
                <p>
                  {' '}
                  <Icon type="file-add" /> {this.state.fileName}
                </p>
              )}
            </Col>
          </Row>
        </Modal>
      </div>
    );
  }
}

const AddFirmware = Form.create()(AddFirmwareForm);
export default AddFirmware;



// WEBPACK FOOTER //
// ./src/components/AppFirmware/AddFirmware.js